/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { makeStyles } from '@mui/styles';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  recentItem: {
    padding: 15,
    backgroundColor: '#f6f7fb',
    width: '17%',
    maxWidth: 310,
    marginRight: 10,
    boxShadow: '0 4px 16px 0 rgba(0, 0, 0, 0.04)',
    border: 'solid 1px #e9e9e9',
    fontSize: 12,
    cursor: 'pointer',
  },
  recentHeader: {
    fontWeight: 'bold',
    marginBottom: 10,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  recentHeaderNoDetails: {
    fontSize: 14,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  recentContent: {
    display: 'flex',
    justifyContent: 'start',
    lineHeight: 1.2,
  },
  recentInfoContainer: {
    width: '49%',
  },
  recentInfoDataItem: {
    marginTop: '3px',
  },
});

const ItemDetail = ({ item, navigateToItemEditor }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const releaseTypeTitle = translateString('Release Type');
  const versionTitle = translateString('Version');

  const hasItemDetails = item.releaseType || item.version;

  return (
    <div
      className={classes.recentItem}
      onClick={() => {
        navigateToItemEditor(item);
      }}
    >
      <div className={hasItemDetails ? classes.recentHeader : classes.recentHeaderNoDetails}>
        {item.name}
      </div>
      {hasItemDetails && (
        <div className={classes.recentContent}>
          {item.releaseType && (
            <div className={classes.recentInfoContainer}>
              <div>{releaseTypeTitle}</div>
              <div className={classes.recentInfoDataItem}>
                <b>{item.releaseType}</b>
              </div>
            </div>
          )}
          {item.version && (
            <div className={classes.recentInfoContainer}>
              <div>{versionTitle}</div>
              <div className={classes.recentInfoDataItem}>
                <b>{item.version}</b>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ItemDetail;
